<lib-page-layout>
  <lib-title-navbar
    pageHeader
    title="Szczegóły gierki"
    [showDots]="true"
    (onDotsClicked)="manageGame()"></lib-title-navbar>

  <div class="or-p-16-px or-bg-white or-min-h-100-pc or-border-box">
    @if (game(); as game) {
      <lib-game-details [game]="game" [showGameTypeDetails]="true" [showGoToChat]="true"></lib-game-details>

      <div class="or-mt-12-px">
        @if (game.playerApplications?.length) {
          <div class="or-head-xs or-color-secondary-2 or-mt-24-px or-mb-12-px">Oczekujący na akceptację</div>
        }
        @for (player of game.playerApplications; track player.gamePlayerApplicationId; let i = $index) {
          <div class="or-d-flex or-justify-content-between">
            <div class="or-d-flex or-align-items-center" [redirectToUserProfile]="player.userId">
              <lib-or-avatar
                [avatarUrl]="player.userThumbnail"
                [initials]="player.userDisplayName"
                [avatarSize]="'sm'"></lib-or-avatar>

              <div class="or-head-sm or-d-flex or-align-items-center" [class.or-opacity-70]="!player.userId">
                {{ i + 1 }}.&nbsp;<span class="or-truncate-at-line-1">{{ player.userDisplayName }}</span>
              </div>
              <div class="or-d-flex or-align-items-center or-ml-8-px">
                @if (player.playerPreferences?.preferredPosition === preferredPosition.GOALKEEPER) {
                  <or-icon name="gk" size="s" class="or-mr-4-px" />
                }
                @for (penalty of player.penalties; track penalty.userPenaltyId) {
                  <img [src]="cardReasonMapper[penalty.penaltyReason!]?.icon" />
                }
              </div>
            </div>
            <div class="or-d-flex or-align-items-center">
              <or-icon
                name="trash"
                size="s"
                boxed
                class="or-mr-4-px"
                (click)="rejectApplication(game.gameId, player.gamePlayerApplicationId)" />

              <or-icon
                name="contact"
                size="s"
                boxed
                class="or-mr-4-px"
                (click)="sendMessage(player.userId, player.userDisplayName)" />

              <or-icon
                name="plus"
                size="s"
                boxed
                class="or-bg-main-1 or-color-white"
                (click)="acceptPlayer(game.gameId, player.gamePlayerApplicationId)" />
            </div>
          </div>

          <div class="or-d-flex or-justify-content-center or-my-4-px">
            <div class="custom-divider-hosted-details or-my-4-px"></div>
          </div>
        }
        @if (game.players?.length) {
          <div class="or-head-xs or-color-secondary-2 or-mt-24-px or-mb-12-px">Lista graczy</div>
        }
        @for (player of game.players; track player.playerId; let i = $index) {
          <div class="or-d-flex or-justify-content-between">
            <div class="or-d-flex or-align-items-center" [redirectToUserProfile]="player.userId">
              <lib-or-avatar
                [avatarUrl]="player.userThumbnail"
                [initials]="player.userDisplayName"
                [avatarSize]="'sm'"></lib-or-avatar>

              <div class="or-head-sm or-truncate-at-line-1" [class.or-opacity-70]="!player.userId">
                {{ i + 1 }}. {{ player.userDisplayName }}
              </div>
              <div class="or-d-flex or-align-items-center or-ml-8-px">
                @if (player.playerPreferences?.preferredPosition === preferredPosition.GOALKEEPER) {
                  <or-icon name="gk" size="s" class="or-mr-4-px" />
                }
                @for (penalty of player.penalties; track penalty.userPenaltyId) {
                  <img [src]="cardReasonMapper[penalty.penaltyReason!]?.icon" />
                }
              </div>
            </div>
            <div class="or-d-flex or-justify-content-end or-align-items-center">
              @if (!player.isHost && player.userId) {
                <or-icon
                  name="contact"
                  size="xs"
                  boxed
                  class="or-color-white or-bg-main-1 or-mr-4-px"
                  (click)="sendMessage(player.userId, player.userDisplayName)" />
              }
              <img
                (click)="changePaymentStatus(player.playerId, player?.isPaid!)"
                src="assets/icons/payment-icon.svg"
                [ngClass]="{ disabled: !player.isPaid }" />

              <or-icon
                (click)="managePlayer(game.gameId, player, true)"
                name="dots-vertical"
                size="m"
                class="or-pl-12-px" />
            </div>
          </div>

          <div class="or-d-flex or-justify-content-center or-my-4-px">
            <div class="custom-divider-hosted-details or-my-4-px"></div>
          </div>
        }
        @if (game.gamePlayersLeft?.length) {
          <div
            (click)="changePlayersLeftVisibility()"
            class="or-mt-24-px or-mb-12-px or-d-flex or-justify-content-between or-align-items-center">
            <div class="or-head-xs or-color-secondary-2">Gracze którzy opuścili gierkę</div>
            <img
              [src]="playersLeftExpanded() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'" />
          </div>
        }
        @if (playersLeftExpanded()) {
          @for (player of game.gamePlayersLeft; track player.playerId; let i = $index) {
            <div class="or-d-flex or-justify-content-between">
              <div class="or-d-flex or-align-items-center" [redirectToUserProfile]="player.userId">
                <lib-or-avatar
                  [avatarUrl]="player.userThumbnail"
                  [initials]="player.userDisplayName"
                  [avatarSize]="'sm'"></lib-or-avatar>

                <div class="or-d-flex or-flex-col">
                  <div class="or-d-flex or-align-items-center">
                    <div class="or-head-sm or-truncate-at-line-1" [class.or-opacity-70]="!player.userId">
                      {{ i + 1 }}. {{ player.userDisplayName }}
                    </div>
                    <div class="or-d-flex or-align-items-center or-ml-8-px">
                      @if (player.playerPreferences?.preferredPosition === preferredPosition.GOALKEEPER) {
                        <or-icon name="gk" size="s" class="or-mr-4-px" />
                      }
                      @for (penalty of player.penalties; track penalty.userPenaltyId) {
                        <img [src]="cardReasonMapper[penalty.penaltyReason!]?.icon" />
                      }
                    </div>
                  </div>

                  @if (player.leaveReasonLabel) {
                    <div class="or-note-sm or-color-secondary-2">{{ player.leaveReasonLabel }}</div>
                  }
                </div>
              </div>

              <div class="or-d-flex or-justify-content-end or-align-items-center">
                @if (!player.isHost && player.userId) {
                  <or-icon
                    name="contact"
                    size="xs"
                    boxed
                    class="or-color-white or-bg-main-1"
                    (click)="sendMessage(player.userId, player.userDisplayName)" />
                }

                <or-icon
                  (click)="managePlayer(game.gameId, player, false)"
                  name="dots-vertical"
                  size="m"
                  class="or-pl-12-px" />
              </div>
            </div>

            <div class="or-d-flex or-justify-content-center or-my-4-px">
              <div class="custom-divider-hosted-details or-my-4-px"></div>
            </div>
          }
        }
        @if (game.invitationsRejected?.length) {
          <div
            (click)="changeInvitationsRejectedVisibility()"
            class="or-mt-24-px or-mb-12-px or-d-flex or-justify-content-between or-align-items-center">
            <div class="or-head-xs or-color-secondary-2">
              Gracze którzy odrzucili zaproszenie ({{ game.invitationsRejected?.length }}/{{
                summaryInvitations(game.invitationsRejected?.length, game.invitations?.length)
              }})
            </div>
            <img
              [src]="
                invitationsRejectedExpanded() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'
              " />
          </div>
        }
        @if (invitationsRejectedExpanded()) {
          @for (player of game.invitationsRejected; track player.gameInvitationId; let i = $index) {
            <div class="or-d-flex or-justify-content-between">
              <div class="or-d-flex or-align-items-center" [redirectToUserProfile]="player.userId">
                <lib-or-avatar
                  [avatarUrl]="player.userThumbnail"
                  [initials]="player.userDisplayName"
                  [avatarSize]="'sm'"></lib-or-avatar>

                <div class="or-head-sm or-truncate-at-line-1">{{ i + 1 }}. {{ player.userDisplayName }}</div>
                <div class="or-d-flex or-align-items-center or-ml-8-px">
                  @for (penalty of player.penalties; track penalty.userPenaltyId) {
                    <img [src]="cardReasonMapper[penalty.penaltyReason!]?.icon" />
                  }
                </div>
              </div>

              <div class="or-d-flex or-justify-content-end or-align-items-center">
                <or-icon
                  name="contact"
                  size="xs"
                  boxed
                  class="or-color-white or-bg-main-1 or-mr-4-px"
                  (click)="sendMessage(player.userId!, player.userDisplayName)" />
              </div>
            </div>

            <div class="or-d-flex or-justify-content-center or-my-4-px">
              <div class="custom-divider-hosted-details or-my-4-px"></div>
            </div>
          }
        }
      </div>

      @if (isInviteOptionsVisible()) {
        <div class="or-mt-24-px">
          <lib-invite-options [game]="game" (onActionPerformed)="refresh()"></lib-invite-options>
        </div>
      }
    }
  </div>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
